import types from "../types"

/* remove */
export default function remove(model, id, callback) {
  return {
    type: types.remove,
    model,
    id,
    callback,
  }
}

remove.success = function removeSuccess(model, id) {
  return {
    type: types.removeSuccess,
    model,
    id,
  }
}

remove.error = function removeError(model, id, error) {
  return {
    type: types.removeError,
    model,
    id,
    error,
  }
}

remove.cancel = function removeCancel(model, id, reason = `No reason`) {
  return {
    type: types.createError,
    model,
    id,
    reason,
  }
}
